import React from "react";
import { Floor, Ocean, GroundEdge } from "../objects";
import type { MapData } from "../../types/MapData.types";

interface MapGroundProps {
  terrain: MapData["terrain"];
  environment: MapData["environment"];
  mapId: string;
}

export default function MapGround({ terrain, environment, mapId }: MapGroundProps) {
  const { ground } = terrain;

  return (
    <>
      {ground && (
        <>
          <Ocean
            groundSize={ground.size as [number, number, number]}
            groundPosition={ground.position as [number, number, number]}
          />
          <GroundEdge
            groundSize={ground.size as [number, number, number]}
            groundPosition={ground.position as [number, number, number]}
            color={ground.colorEdge}
          />
        </>
      )}
      {ground?.type === "plane" && (
        <Floor
          size={ground.size}
          position={ground.position}
          mapId={mapId}
          colorInner={ground.colorInner}
          colorOuter={ground.colorOuter}
          innerColorPercent={ground.innerColorPercent}
        />
      )}
    </>
  );
}
